import Image from 'next/image';

import { ArrowIcon, LogoIcon } from '@endaoment-frontend/ui/icons';
import { Button, Card } from '@endaoment-frontend/ui/shared';

import charlesSchwabLogo from '../../../images/logos/charles-schwab-logo.svg';
import fidelityLogo from '../../../images/logos/fidelity-logo.svg';
import { CardTable } from '../../cardTable';
import { SectionLabel } from '../../sectionLabel';

import styles from './FeeComparison.module.scss';

export const FeeComparison = () => {
  return (
    <section className={styles['fee-section']}>
      <Card className={styles['fee-comparison']}>
        <SectionLabel text="Fee Comparison" smaller />
        <CardTable headers={['Service', 'Donation Fee', 'Granting Fee', 'Total Fee']}>
          <CardTable.Row>
            <CardTable.Col>
              <div className={styles['logo-cell']}>
                <LogoIcon color="currentColor" />
                for Donors
              </div>
            </CardTable.Col>
            <CardTable.Col center>0.5%</CardTable.Col>
            <CardTable.Col center>1.0%</CardTable.Col>
            <CardTable.Col center>1.5%</CardTable.Col>
          </CardTable.Row>
          <CardTable.Row>
            <CardTable.Col header colSpan={4} className={styles['full-row-col']}>
              <hr />
            </CardTable.Col>
          </CardTable.Row>
          <CardTable.Row className={styles['fake-second-header']}>
            <CardTable.Col header>&nbsp;</CardTable.Col>
            <CardTable.Col header>Admin Fee</CardTable.Col>
            <CardTable.Col header>Investment Fee</CardTable.Col>
            <CardTable.Col header>Total Fee*</CardTable.Col>
          </CardTable.Row>
          <CardTable.Row>
            <CardTable.Col>
              <Image src={charlesSchwabLogo} alt="Charles Schwab" width={190} height={25} />
            </CardTable.Col>
            <CardTable.Col center>1.2%</CardTable.Col>
            <CardTable.Col center>1.6%</CardTable.Col>
            <CardTable.Col center>2.8%</CardTable.Col>
          </CardTable.Row>
          <CardTable.Row>
            <CardTable.Col>
              <Image src={fidelityLogo} alt="Fidelity" width={140} height={33} />
            </CardTable.Col>
            <CardTable.Col center>1.2%</CardTable.Col>
            <CardTable.Col center>1.2%</CardTable.Col>
            <CardTable.Col center>2.4%</CardTable.Col>
          </CardTable.Row>
        </CardTable>
        <Button
          as="a"
          size="small"
          href="https://docs.endaoment.org/donors/fee-schedule"
          target="_blank"
          rel="noreferrer"
        >
          Read more about fees
          <ArrowIcon width={20} />
        </Button>
      </Card>
      <p className={styles['fee-footnote']}>*Based on 4.5yr average granting schedule</p>
    </section>
  );
};
